import React, { useState } from 'react';
import QuickLogModal from './QuickLogModal';

const QuickLogButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {/* Premium Quick Log Button with glassmorphism */}
      <div className="mb-8 fade-in">
        <button
          onClick={() => setIsModalOpen(true)}
          className="btn-primary inline-flex items-center space-x-3 group hover-lift"
        >
          <div className="flex items-center justify-center w-5 h-5 bg-white/20 rounded-full group-hover:bg-white/30 transition-colors duration-300">
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
            </svg>
          </div>
          <span className="font-semibold">Quick Log Entry</span>
          <div className="flex space-x-1 opacity-60 group-hover:opacity-80 transition-opacity duration-300">
            <div className="w-1 h-1 bg-white rounded-full"></div>
            <div className="w-1 h-1 bg-white rounded-full"></div>
            <div className="w-1 h-1 bg-white rounded-full"></div>
          </div>
        </button>
      </div>

      {/* Premium Mobile Floating Action Button (FAB) */}
      <div className="fixed bottom-6 right-6 z-50 md:hidden">
        <button
          onClick={() => setIsModalOpen(true)}
          className="relative group"
        >
          {/* FAB main button */}
          <div className="w-14 h-14 bg-teal-500 rounded-full shadow-premium flex items-center justify-center backdrop-blur-xl border border-white/20 transition-all duration-300 group-hover:shadow-premium-lg group-hover:scale-110 group-active:scale-95">
            {/* Gradient overlay */}
            <div className="absolute inset-0 rounded-full bg-gradient-to-br from-teal-400 to-teal-600 opacity-90"></div>
            
            {/* Plus icon */}
            <svg className="w-6 h-6 text-white relative z-10 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
            </svg>
            
            {/* Shine effect */}
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-transparent via-white/30 to-transparent transform -skew-x-12 opacity-0 group-hover:opacity-100 group-hover:translate-x-full transition-all duration-700"></div>
          </div>
          
          {/* Pulse ring animation */}
          <div className="absolute inset-0 rounded-full border-2 border-teal-400/50 animate-ping"></div>
          
          {/* Tooltip */}
          <div className="absolute bottom-full right-0 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            <div className="bg-glass-whiteStrong backdrop-blur-xl border border-white/40 rounded-2xl px-3 py-2 text-xs font-medium text-neutral-700 whitespace-nowrap shadow-glass">
              Quick Log
              <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-white/40"></div>
            </div>
          </div>
        </button>
      </div>

      {/* Premium Quick Log Modal */}
      <QuickLogModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
};

export default QuickLogButton;